import React from "react";
import LogoLayout from "../../components/logolayout/logolayout";
import TextInput from "../../components/form/inputs/text-input/text-input";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../config/axios";
import { showToast } from "../../utils/utils";
import { useAppContext } from "../../context/app.context";

export default function LoginPage() {
  const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const { setAppInfos } = useAppContext();
  const navigate = useNavigate();
  async function onSubmit(form: any) {
    try {
      const { data } = await axiosInstance.post("login", form);
      if (data.user.role != "ADMIN") return showToast("Les informations de connexion sont incorrectes");
      setAppInfos({ token: data.token, user: data.user });
      navigate("/");
    } catch (e: any) {
      if (e?.response?.status == 422) showToast("Les informations de connexion sont incorrectes");
      else showToast("Une erreur est survenue");
    }
  }
  return (
    <LogoLayout submitTitle="Se connecter" onSubmit={onSubmit} hideBack={true}>
      <h1>Bienvenue !</h1>
      <h2 className="title">Se connecter</h2>
      <div>
        <TextInput
          validate={(val: any) => (!emailReg.test(val) ? "Adresse e-mail invalide" : true)}
          name="email"
          autocomplete="off"
          type="email"
          placeHolder="Votre email"
          label="Adresse e-mail"
        />
        <TextInput
          autocomplete="off"
          showPassword
          name="password"
          type="password"
          required="Mot de passe invalide"
          placeHolder="Votre mot de passe"
          label="Mot de passe"
        />
      </div>
    </LogoLayout>
  );
}
